import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'
import { getIdData } from '../../lib/studentinfo'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'
import { StudentInfoModal } from './StudentInfoModal'

const StudentHeaderInfo = ({ studentId, isSidebar = false }) => {
	const [studentInfo, setStudentInfo] = useState(null)
	const [loading, setLoading] = useState(true)
	const [showModal, setShowModal] = useState(false)
	const [isStudent911, setIsStudent911] = useState(false)
	const [isStudent12, setIsStudent12] = useState(false)

	const layout = useLayout()
	const role = useRoleBasedUrl()

	const fetchStudentData = async () => {
		if (!studentId) return

		try {
			setLoading(true)
			const std = await getIdData(studentId)
			if (std && std.length > 0) {
				const student = std[0]
				setStudentInfo(student)

				// Determine student role
				if (student.role === 'Student911') {
					setIsStudent911(true)
					setIsStudent12(false)
				} else if (student.role === 'Student12') {
					setIsStudent12(true)
					setIsStudent911(false)
				}
			}
		} catch (error) {
			console.error('Error fetching student data:', error)
		} finally {
			setLoading(false)
		}
	}

	const toggleModal = () => {
		setShowModal(!showModal)
	}

	useEffect(() => {
		if (studentId) {
			fetchStudentData()
		}
	}, [studentId])

	if (loading) {
		return (
			<div className={`d-flex align-items-center ${isSidebar ? 'justify-content-center p-3' : ''}`}>
				<div className="spinner-border spinner-border-sm text-primary me-2" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
				{!isSidebar && <span>Loading student...</span>}
			</div>
		)
	}

	if (!studentInfo) {
		return null
	}

	return (
		<>
			<div className={`d-flex ${isSidebar ? 'flex-column align-items-center text-center p-3 border-bottom mb-2' : ''}`}>
				{/* Student Name and Info Button */}
				<div className={`d-flex align-items-center ${isSidebar ? 'mb-2' : 'me-3'}`}>
					{/* Info Button */}
					<Button
						color="outline-info"
						size="sm"
						className="me-2 p-1"
						onClick={toggleModal}
						title="View Student Details"
						style={{
							width: '24px',
							height: '24px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							borderRadius: '6px'
						}}
					>
						<i className="fa fa-chevron-down" style={{ fontSize: '10px' }}></i>
					</Button>
					<h6 className={`mb-0 fw-bold text-dark ${isSidebar ? 'fs-6' : ''}`}>
						{studentInfo.name ? `${studentInfo.name} ${studentInfo.surname || ''}`.trim() : 'Student Name Not Found'}
					</h6>
				</div>

				{/* Action Buttons Group */}
				<div className={`d-flex align-items-center ${isSidebar ? 'gap-2' : ''}`}>
					{/* Profile Links */}
					<div className={isSidebar ? '' : 'me-3'}>
						{isStudent911 && (
							<Link
								to={`${process.env.PUBLIC_URL}/${role}/student-college-profile/${studentId}/${layout}`}
								className="btn btn-outline-primary btn-sm"
								style={{ fontSize: '10px', padding: '2px 6px' }}
							>
								College Profile
							</Link>
						)}
						{isStudent12 && (
							<Link
								to={`${process.env.PUBLIC_URL}/${role}/student-application-profile/${studentId}/${layout}`}
								className="btn btn-outline-primary btn-sm"
								style={{ fontSize: '10px', padding: '2px 6px' }}
							>
								App. Profile
							</Link>
						)}
					</div>

					{/* Zoom and Folder Links */}
					<div className="d-flex align-items-center">
						{/* Zoom Icon */}
						{(studentInfo.meetlink || isStudent12) && (
							<Link
								to={studentInfo.meetlink || '#'}
								target={studentInfo.meetlink ? '_blank' : '_self'}
								className="me-1 btn btn-outline-primary btn-sm p-1"
								title={studentInfo.meetlink ? 'Join Zoom Meeting' : 'Zoom Meeting (No Link)'}
								style={{
									width: '24px',
									height: '24px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									borderRadius: '6px',
									opacity: studentInfo.meetlink ? 1 : 0.5
								}}
							>
								<i className="fa fa-video-camera" style={{ fontSize: '11px' }}></i>
							</Link>
						)}

						{/* Folder Icon */}
						{(studentInfo.folderlink || isStudent12) && (
							<Link
								to={studentInfo.folderlink || '#'}
								target={studentInfo.folderlink ? '_blank' : '_self'}
								className="btn btn-outline-success btn-sm p-1"
								title={studentInfo.folderlink ? 'Open Student Folder' : 'Student Folder (No Link)'}
								style={{
									width: '24px',
									height: '24px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									borderRadius: '6px',
									opacity: studentInfo.folderlink ? 1 : 0.5
								}}
							>
								<i className="fa fa-folder" style={{ fontSize: '11px' }}></i>
							</Link>
						)}
					</div>
				</div>
			</div>

			{/* Student Info Modal */}
			<StudentInfoModal isOpen={showModal} toggle={toggleModal} studentId={studentId} />
		</>
	)
}

export { StudentHeaderInfo }
